export enum NotificationEnums {
  'LOADING',
  'SUCCESS',
  'ERROR',
  'INFO',
  'WARNING',
}

export enum NotificationTitles {
  NOT_NOW_TOAST = 'Access Low-Data Mode from Settings > Low-Data Mode for a smooth class experience',
  QUALITY_OPTIONS_DISABLED_TOAST = 'Quality Options are not applicable in Low-Data Mode',
  SPEED_OPTIONS_DISABLED_TOAST = 'Speed Options are not applicable in Low-Data Mode',
  LOW_DATA_MODE_ENABLED_TOAST = "Low Data Mode is 'On'",
  LOW_DATA_MODE_DISABLED_TOAST = "Low Data Mode is 'Off'",
  INTERNET_FLUCTUATION = 'Your internet connection is fluctuating. Please refresh the page once it stabilizes',
  POLICY_ACK_FAILED = 'Failed to update policy acknowledgement status. Please try again.',
  WEBRTC_PROCESSING_TOAST = 'The video is currently available in 720p quality. Please wait a little while as we finish processing to unlock other quality options.',
  WEBRTC_PROCESSING_QUALITY_TOAST = 'Video is still processing other quality options will be available shortly.',
}

export enum Theme {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
  YELLOW = 'YELLOW',
  OTT = 'OTT',
}

export enum NotificationPosition {
  TOP_LEFT = 'top_left',
  TOP_CENTER = 'top_center',
  TOP_RIGHT = 'top_right',
  BOTTOM_LEFT = 'bottom_left',
  BOTTOM_CENTER = 'bottom_center',
  BOTTOM_RIGHT = 'bottom_right',
  BOTTOM_LEFT_ABOVE_FOOTER = 'bottom_left_above_footer',
}
export enum AnimationPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  RIGHT = 'right',
  LEFT = 'left',
}
export const themeMap: Record<Theme, { backgroundColor: string; textColor: string }> = {
  [Theme.LIGHT]: {
    backgroundColor: 'bg-white',
    textColor: 'text-pw-gray-palette-900-pw-neutral',
  },
  [Theme.DARK]: {
    backgroundColor: 'bg-customDarkGray',
    textColor: 'text-white',
  },
  [Theme.YELLOW]: {
    backgroundColor: 'bg-[#F7E0B4]',
    textColor: 'text-[#543D11]',
  },
  [Theme.OTT]: {
    backgroundColor: 'bg-customDarkGray',
    textColor: 'white-overlay',
  },
};

export enum NotificationDuration {
  'SHORT' = 2000,
  'LONG' = 4000,
  'VERY_LONG' = 7000,
  'NONE' = 10000,
  'EXTENDED' = 15000,
  'INFINITE' = 100000000,
}

export interface NotificationType {
  message?: string;
  title?: any;
  duration?: NotificationDuration;
  identifier?: string;
  description?: string;
  onClose?: () => void;
  timestamp?: any;
  type: NotificationEnums;
  content?: any;
  position?: NotificationPosition;
  theme?: Theme;
  extraClasses?: any;
  hideCrossIcon?: boolean;
  actionLabel?: string;
  onAction?: () => void;
}

export const NotificationChannel = 'NotificationChannel';
const useNotify = () => {
  const showNotification = (data: NotificationType) => {
    const evt = new CustomEvent(NotificationChannel, {
      bubbles: false,
      cancelable: true,
      composed: false,
      detail: {
        ...data,
        duration: data.duration || NotificationDuration.NONE,
        actionLabel: data.actionLabel,
        onAction: data.onAction,
        position: NotificationPosition.TOP_CENTER,
      },
    });
    window.dispatchEvent(evt);
  };
  return {
    showNotification,
  };
};
export default useNotify;
